"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMakeDeposit = void 0;
var keys_1 = require("../keys");
var react_1 = require("react");
var useMutation_1 = require("../useMutation");
var useMakeDeposit = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        keysUpdate: [keys_1.BALANCE],
        path: keys_1.DEPOSIT_MAKE,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        makeDeposit: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useMakeDeposit = useMakeDeposit;
